export default __webpack_public_path__ + "static/media/unsound.7722c33b.svg";